module.exports = __webpack_public_path__ + "static/media/torqueing-bolting.df072b0f.jpg";